module.exports = __webpack_public_path__ + "img/g10.fa732fab.jpg";